import { useEffect } from 'react';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';
import { IS_PRERENDER } from '@/lib/hydration';

let active: Lenis | null = null;

export function useSmoothScroll() {
  useEffect(() => {
    if (IS_PRERENDER || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const lenis = new Lenis({ lerp: 0.085, wheelMultiplier: 0.9, autoRaf: true, anchors: { offset: -72 } });
    active = lenis;
    return () => { lenis.destroy(); if (active === lenis) active = null; };
  }, []);
}

/** Jumps to an element, leaving `offset` px (negative = above it) for fixed bars. */
export function scrollToElement(el: HTMLElement, offset = -72) {
  if (active) active.scrollTo(el, { offset, immediate: true });
  else window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY + offset });
}

/** Freezes page scrolling (smooth or native) while an overlay is open. */
export function lockPageScroll(locked: boolean) {
  if (locked) active?.stop(); else active?.start();
  document.documentElement.style.overflow = locked ? 'hidden' : '';
}
